// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3YiI7","footer":"ModalUpdate_footer__30Hj8"};